<template>
  <basic-page title="Pelastuskorttitietokanta">
    <v-row class="fill-height">
      <v-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
        <pelastuskortti-selain />
      </v-col>
    </v-row>
  </basic-page>
</template>

<script>
import BasicPage from "@/components/BasicPage";
import PelastuskorttiSelain from "@/components/PelastuskorttiSelain";

export default {
  name: "PelastuskorttiTietokanta",
  components: { BasicPage, PelastuskorttiSelain },
};
</script>
